import { supabase } from './supabase';

export async function getPrimaryWorkspaceId(): Promise<string | null> {
  const { data, error } = await supabase
    .from('workspaces')
    .select('id, created_at')
    .order('created_at', { ascending: true })
    .limit(1)
    .maybeSingle();
  if (error) throw error;
  return data?.id ?? null;
}

/**
 * Workspace for a new audit: an explicit ?workspace=<id> deep link wins
 * (RLS scopes the lookup to workspaces the user can read), otherwise the
 * user's oldest workspace as before.
 */
export async function getTargetWorkspaceId(): Promise<string | null> {
  const requested = new URLSearchParams(window.location.search).get('workspace');
  if (requested) {
    const { data } = await supabase
      .from('workspaces')
      .select('id')
      .eq('id', requested)
      .maybeSingle();
    if (data?.id) return data.id;
  }
  return getPrimaryWorkspaceId();
}
